export default __webpack_public_path__ + "static/media/logo.dcf5861f.png";